<template>
  <div>
    <div class="newQuestionsBackground md:py-12 dark:bg-purple-600">
      <div class="buttonDiv">
        <BackButton />
        <h2 class="questionTitle dark:text-white">
          Which of the following best describes your status as a student?
        </h2>
        <div data-aos="fade-left" class="radio-toolbar">
          <!-- Q2-1-->

          <span
            v-if="$store.state.views.questionTwo.checkedButtons[0] === idArr[0]"
          >
            <input
              type="radio"
              id="option1"
              v-on:click="setNextQuestionBTrue"
              name="question2-1"
              value="Undergraduate"
              checked
            />

            <label for="option1" class="dark:text-white dark:bg-hero-purple">
              {{ answerOptions1[0] }}</label
            >
          </span>

          <span v-else>
            <input
              type="radio"
              id="option1"
              v-on:click="setNextQuestionBTrue"
              name="question2-1"
              value="Undergraduate"
            />

            <label for="option1" class="dark:text-white dark:bg-hero-purple">
              {{ answerOptions1[0] }}</label
            >
          </span>

          <!-- Q2-2-->

          <span
            v-if="$store.state.views.questionTwo.checkedButtons[0] === idArr[1]"
          >
            <input
              type="radio"
              id="option2"
              v-on:click="setNextQuestionATrue"
              name="question2-1"
              value="Graduate"
              checked
            />

            <label for="option2" class="dark:text-white dark:bg-hero-purple">
              {{ answerOptions1[1] }}</label
            >
          </span>

          <span v-else>
            <input
              type="radio"
              id="option2"
              v-on:click="setNextQuestionATrue"
              name="question2-1"
              value="Graduate"
            />

            <label for="option2" class="dark:text-white dark:bg-hero-purple">
              {{ answerOptions1[1] }}</label
            >
          </span>
        </div>

        <div
          class="spacingDiv"
          data-aos="fade-left"
          v-if="
            undergraduate ||
            $store.state.views.questionTwo.nextPartofQuestion[2] === true
          "
        >
          <h2 class="questionTitle dark:text-white">
            Are you a new student or a first-year student?
          </h2>
          <div class="radio-toolbar">
            <!-- Q2-1-A-->

            <span
              v-if="
                $store.state.views.questionTwo.checkedButtons[3] === idArr[2]
              "
            >
              <input
                type="radio"
                id="option2-2-1"
                v-on:click="setNextQuestionTrue"
                name="question2-2A"
                value="First year"
                checked
              />

              <label
                for="option2-2-1"
                class="dark:text-white dark:bg-hero-purple"
              >
                {{ answerOptions2[0] }}</label
              >
            </span>

            <span v-else>
              <input
                type="radio"
                id="option2-2-1"
                v-on:click="setNextQuestionTrue"
                name="question2-2A"
                value="First year"
              />

              <label
                for="option2-2-1"
                class="dark:text-white dark:bg-hero-purple"
              >
                {{ answerOptions2[0] }}</label
              >
            </span>

            <!-- Q2-1-B-->

            <span
              v-if="
                $store.state.views.questionTwo.checkedButtons[3] === idArr[3]
              "
            >
              <input
                type="radio"
                id="option2-2-2"
                v-on:click="setNextQuestionTrue"
                name="question2-2A"
                value="Upper"
                checked
              />

              <label
                for="option2-2-2"
                class="dark:text-white dark:bg-hero-purple"
              >
                {{ answerOptions2[1] }}</label
              >
            </span>

            <span v-else>
              <input
                type="radio"
                id="option2-2-2"
                v-on:click="setNextQuestionTrue"
                name="question2-2A"
                value="Upper"
              />

              <label
                for="option2-2-2"
                class="dark:text-white dark:bg-hero-purple"
              >
                {{ answerOptions2[1] }}</label
              >
            </span>
          </div>
        </div>

        <div
          class="spacingDiv"
          data-aos="fade-left"
          v-if="
            showNextQuestion[0] === true ||
            $store.state.views.questionTwo.nextPartofQuestion[0] === true
          "
        >
          <h2 class="questionTitle dark:text-white">
            Are you an international student studying at Carleton?
          </h2>
          <div class="radio-toolbar">
            <!-- Q2-3-1-->

            <span
              v-if="
                $store.state.views.questionTwo.checkedButtons[1] === idArr[4]
              "
            >
              <input
                type="radio"
                id="option2-3-1"
                v-on:click="setLastQuestionTrue"
                name="question2-3"
                value="International"
                checked
              />

              <label
                for="option2-3-1"
                class="dark:text-white dark:bg-hero-purple"
              >
                {{ answerOptions3[0] }}</label
              >
            </span>

            <span v-else>
              <input
                type="radio"
                id="option2-3-1"
                v-on:click="setLastQuestionTrue"
                name="question2-3"
                value="International"
              />

              <label
                for="option2-3-1"
                class="dark:text-white dark:bg-hero-purple"
              >
                {{ answerOptions3[0] }}</label
              >
            </span>

            <!-- Q2-3-2-->

            <span
              v-if="
                $store.state.views.questionTwo.checkedButtons[1] === idArr[5]
              "
            >
              <input
                type="radio"
                id="option2-3-2"
                v-on:click="setLastQuestionTrue"
                name="question2-3"
                value="Domestic"
                checked
              />

              <label
                for="option2-3-2"
                class="dark:text-white dark:bg-hero-purple"
              >
                {{ answerOptions3[1] }}</label
              >
            </span>

            <span v-else>
              <input
                type="radio"
                id="option2-3-2"
                v-on:click="setLastQuestionTrue"
                name="question2-3"
                value="Domestic"
              />

              <label
                for="option2-3-2"
                class="dark:text-white dark:bg-hero-purple"
              >
                {{ answerOptions3[1] }}</label
              >
            </span>
          </div>
        </div>

        <div
          class="spacingDiv"
          data-aos="fade-left"
          v-if="
            showNextQuestion[1] ||
            $store.state.views.questionTwo.nextPartofQuestion[1] === true
          "
          id="Q2_part_4"
        >
          <h2 class="questionTitle dark:text-white">
            Where are you currently living?
          </h2>
          <div class="radio-toolbar">
            <!-- Q2-4-1-->

            <span
              v-if="
                $store.state.views.questionTwo.checkedButtons[2] === idArr[6]
              "
            >
              <input
                type="radio"
                id="option2-4-1"
                v-on:click="setNextButtonTrue"
                name="question2-4"
                value="Ottawa"
                checked
              />

              <label
                for="option2-4-1"
                class="dark:text-white dark:bg-hero-purple"
              >
                {{ answerOptions4[0] }}</label
              >
            </span>

            <span v-else>
              <input
                type="radio"
                id="option2-4-1"
                v-on:click="setNextButtonTrue"
                name="question2-4"
                value="Ottawa"
              />

              <label
                for="option2-4-1"
                class="dark:text-white dark:bg-hero-purple"
              >
                {{ answerOptions4[0] }}</label
              >
            </span>

            <!-- Q2-4-2-->

            <span
              v-if="
                $store.state.views.questionTwo.checkedButtons[2] === idArr[7]
              "
            >
              <input
                type="radio"
                id="option2-4-2"
                v-on:click="setNextButtonTrue"
                name="question2-4"
                value="Abroad"
                checked
              />

              <label
                for="option2-4-2"
                class="dark:text-white dark:bg-hero-purple"
              >
                {{ answerOptions4[1] }}</label
              >
            </span>

            <span v-else>
              <input
                type="radio"
                id="option2-4-2"
                v-on:click="setNextButtonTrue"
                name="question2-4"
                value="Abroad"
              />

              <label
                for="option2-4-2"
                class="dark:text-white dark:bg-hero-purple"
              >
                {{ answerOptions4[1] }}</label
              >
            </span>

            <!-- Q2-4-3-->

            <span
              v-if="
                $store.state.views.questionTwo.checkedButtons[2] === idArr[8]
              "
            >
              <input
                type="radio"
                id="option2-4-3"
                v-on:click="setNextButtonTrue"
                name="question2-4"
                value="Residence"
                checked
              />

              <label
                for="option2-4-3"
                class="dark:text-white dark:bg-hero-purple"
              >
                {{ answerOptions4[2] }}</label
              >
            </span>

            <span v-else>
              <input
                type="radio"
                id="option2-4-3"
                v-on:click="setNextButtonTrue"
                name="question2-4"
                value="Residence"
              />

              <label
                for="option2-4-3"
                class="dark:text-white dark:bg-hero-purple"
              >
                {{ answerOptions4[2] }}</label
              >
            </span>

            <!-- Q2-4-4-->

            <span
              v-if="
                $store.state.views.questionTwo.checkedButtons[2] === idArr[9]
              "
            >
              <input
                type="radio"
                id="option2-4-4"
                v-on:click="setNextButtonTrue"
                name="question2-4"
                value="Canada"
                checked
              />

              <label
                for="option2-4-4"
                class="dark:text-white dark:bg-hero-purple"
              >
                {{ answerOptions4[3] }}</label
              >
            </span>

            <span v-else>
              <input
                type="radio"
                id="option2-4-4"
                v-on:click="setNextButtonTrue"
                name="question2-4"
                value="Canada"
              />

              <label
                for="option2-4-4"
                class="dark:text-white dark:bg-hero-purple"
              >
                {{ answerOptions4[3] }}</label
              >
            </span>
          </div>
        </div>
      </div>
    </div>

    <div
      class="
        alignFooter
        dark:bg-hero-purple
        border-b border-gray-200
        dark:border-hero-purple
      "
    >
      <div class="footerContainer">
        <HelpDialog />

        <button
          v-if="
            isActive || $store.state.views.questionTwo.nextButtonActive == true
          "
          v-on:click="nextQuestion"
          class="nextButtonQuestions"
        >
          Next
          <span class="arrow">
            <svg
              width="14"
              height="12"
              viewBox="0 0 14 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.63466 0.298041C8.45622 0.109282 8.20838 0 7.9308 0C7.38556 0 6.93945 0.447062 6.93945 0.99347C6.93945 1.27164 7.0485 1.52001 7.22694 1.69883L10.4885 4.96735H0.99135C0.446108 4.96735 0 5.41441 0 5.96082C0 6.50723 0.446108 6.95429 0.99135 6.95429H10.4984L7.23686 10.2228C7.05842 10.4016 6.94937 10.65 6.94937 10.9282C6.94937 11.4746 7.39547 11.9216 7.94072 11.9216C8.2183 11.9216 8.46613 11.8124 8.64458 11.6335L13.6013 6.66618C13.7798 6.48736 13.8888 6.23899 13.8888 5.96082C13.8888 5.68265 13.7699 5.44422 13.5914 5.26539L8.63466 0.298041Z"
                fill="#8380A8"
              />
            </svg>
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import store from "../store";
import BackButton from "./BackButton.vue";
import HelpDialog from "./HelpDialog.vue";
export default {
  data() {
    return {
      idArr: {
        0: "option1",
        1: "option2",
        2: "option2-2-1",
        3: "option2-2-2",
        4: "option2-3-1",
        5: "option2-3-2",
        6: "option2-4-1",
        7: "option2-4-2",
        8: "option2-4-3",
        9: "option2-4-4",
      },
      answerOptions1: {
        0: "Undergraduate",
        1: "Graduate",
      },
      answerOptions2: {
        0: "Yes",
        1: "No",
      },
      answerOptions3: {
        0: "Yes",
        1: "No",
      },
      answerOptions4: {
        0: "Ottawa",
        1: "Abroad",
        2: "Residence",
        3: "Outside of Ottawa (in Canada)",
      },
      showNextQuestion: {
        0: false,
        1: false,
      },
      isActive: false,
      undergraduate: false,
    };
  },

  components: {
    BackButton,
    HelpDialog,
  },

  mounted: function () {
    this.scrollToTop();
    this.track();
  },

  methods: {
    track() {
      const currentURL = new URL(location.href);
      const isDemo = currentURL.searchParams.get('demo') === 'true';

      if (!isDemo) {
        this.$gtag.pageview({ page_path: "step2" });
      } else if(isDemo) {
        console.log("Demo Mode: no event tracking");
      }
    },
    nextQuestion() {
      // grab the associated options selected and pass to google analytics event
      // event could be called q-2 answers

      var answerArray = [];
      var activeChecked = [];

      this.findCheckedID("question2-1", activeChecked, 0);
      this.findChecked("question2-1", answerArray);

      this.findCheckedID("question2-3", activeChecked, 1);
      this.findChecked("question2-3", answerArray);

      this.findCheckedID("question2-4", activeChecked, 2);
      this.findChecked("question2-4", answerArray);

      if (this.undergraduate || this.ifOneChecked("question2-2A")) {
        this.findCheckedID("question2-2A", activeChecked, 3);
        this.findChecked("question2-2A", answerArray);
      }

      for (let i = 0; i < answerArray.length; i++) {
        const currentURL = new URL(location.href);
        const isDemo = currentURL.searchParams.get('demo') === 'true';

        if (!isDemo) {
            this.$gtag.event("q2-answer", {
            event_category: "answers",
            event_label: answerArray[i],
          });
        } else if(isDemo) {
          console.log("Demo Mode: no event tracking");
      }
      }
      var objectForPages = {
        index: '["questionTwo"]',
        ans: answerArray,
      };

      var objectForChecked = {
        questionNum: '["questionTwo"]',
        checkedButtons: activeChecked,
      };

      store.commit("addAnswer", objectForPages);
      store.commit("setNextButtonActive", '["questionTwo"]');
      store.commit("setChecked", objectForChecked);
      store.commit("updatePage", '["questionTen"]');
    },

    resetAll: function (name) {
      var ele = document.getElementsByName(name);
      for (var i = 0; i < ele.length; i++) {
        ele[i].checked = false;
      }
    },

    findChecked: function (name, arr) {
      var check = document.querySelector(
        "input[name = " + name + "]:checked"
      ).value;
      arr.push(check);
    },

    setNextQuestionATrue() {
      this.isActive = false;
      this.showNextQuestion[0] = true;
      var objectForPageRemove = {
        index: '["questionTwo"]',
        questionNum: 2,
      };

      store.commit("removeNextQuestions", objectForPageRemove);
      this.resetAll("question2-2A");
      this.undergraduate = false;
      if (this.ifOneChecked("question2-4")) {
        this.isActive = true;
      }
    },

    setNextQuestionBTrue() {
      this.isActive = false;
      this.undergraduate = true;
      store.commit("setNextButtonDeactive", '["questionTwo"]');

      if (store.getters.questionTwoOption !== undefined) {
        store.commit("setNextButtonActive", '["questionTwo"]');
      }
    },

    nextButtonCheckAgainstQ2A() {
      var optionOneSelection = [];
      this.findChecked("question2-1", optionOneSelection);
      if (
        optionOneSelection[0] === "Undergraduate" &&
        !this.ifOneChecked("question2-2A")
      ) {
        this.isActive = false;
      }
    },

    setLastQuestionTrue() {
      this.isActive = false;
      this.showNextQuestion[1] = true;

      this.scrollToBottom();

      if (this.ifOneChecked("question2-4")) {
        this.isActive = true;
      }

      this.nextButtonCheckAgainstQ2A();
    },

    setNextQuestionTrue() {
      this.isActive = false;
      this.showNextQuestion[0] = true;
      if (this.ifOneChecked("question2-4")) {
        this.isActive = true;
      }
    },

    setNextButtonTrue() {
      this.isActive = true;

      this.nextButtonCheckAgainstQ2A();
    },

    ifOneChecked: function (name) {
      var ele = document.getElementsByName(name);
      for (var i = 0; i < ele.length; i++) {
        if (ele[i].checked === true) {
          return true;
        }
      }
      return false;
    },

    findCheckedID: function (name, arr, index) {
      var check = document.querySelector(
        "input[name = " + name + "]:checked"
      ).id;
      arr[index] = check;
    },

    scrollToTop: function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },

    scrollToBottom: function () {
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: "smooth",
      });
    },
  },
};
</script>
